import axios from 'axios'
import { ElMessage, ElNotification } from 'element-plus'
// import { getToken } from "@/utils/auth"
// import { useErrorStore } from '@/store/store'
// import router from '@/router'
import { getToken, removeToken } from "@/utils/auth"
import router from '@/router'

// create an axios instance
const service = axios.create({ //need change this, import getLite and then do if-else
    baseURL: process.env.VUE_APP_API_URL, // url = base url + request url
    withCredentials: false, // send cookies when cross-domain requests
    timeout: (60000*20) // request timeout
})


// ===== Pending Requests Handling =====
const pendingRequests = {}

const getRequestKey = config => {
    const { url, method, params = {}, data = {} } = config
    // If params include `type`, allow multiple → don't abort duplicates
    if (params && params.type !== undefined) { 
        return `${method}:${url}?type=${params.type}${(config.queueId??"")}`
    }

    // Otherwise, include params + data → ensures uniqueness

    if (url.includes('/settings/columns/list')) {
        return `${method}:${url}?${JSON.stringify(params)}&${JSON.stringify(
            data
        )}${(config.queueId??"")}`
    }

    return `${method}:${url}${(config.queueId??"")}`
}

const addPendingRequest = config => {
    const key = getRequestKey(config)
    // If duplicate request exists, cancel it
    if (pendingRequests[key]) {
        pendingRequests[key].abort()
        delete pendingRequests[key]
    }
    const controller = new AbortController()
    config.signal = controller.signal
    pendingRequests[key] = controller
    config.requestKey = key // store key inside config for cleanup later
}

const removePendingRequest = (config, abort = false) => {
    if (!config?.requestKey) return
    const key = config.requestKey
    if (pendingRequests[key]) {
        if (abort) {
            pendingRequests[key].abort()
            delete pendingRequests[key]
        }
    }
}

// request interceptor
service.interceptors.request.use(
    config => {
        addPendingRequest(config)
        const token = getToken()
        const lang = localStorage.getItem('i18n') === 'ms' ? 'ms-MY' : 'en-US'  
        config.headers['Accept-Language'] = lang
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        if (config.bypassTimeout) {
            config.timeout = 0 
            delete config.bypassTimeout 
        }

        if (config.queueId) {
           // delete config.queueId 
        }
        if (typeof config.timeout === 'number') {
            // Axios will use this timeout automatically
        }
        return config
    },
    error => {
        // do something with request error
        return Promise.reject(error)
    }
)

// let lastErrorStatus = null   // prevent repeated redirects

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        removePendingRequest(response.config)
        const { data, status } = response
        // if the custom code is not 20000, it is judged as an error.
        if (status !== 200) {
            ElMessage({
                message: data.message || 'Error',
                type: 'error',
                duration: 5 * 1000
            })
            return Promise.reject(new Error(data.message || 'Error'))
        }
        else {
            return data
        }
    },
    async error => {
        removePendingRequest(error.config)
      
        // const { response } = error
        // const { data } = response
        // const { message } = data
        // const config = error.config

        // // Retry logic: handle ERR_NETWORK_CHANGED
        // if (
        //     error.message === 'Network Error' &&
        //     error?.code === 'ERR_NETWORK_CHANGED'
        // ) {
        //     config.__retryCount = config.__retryCount || 0
        //     if (config.__retryCount < 5) {
        //     config.__retryCount += 1
        //     await new Promise(resolve => setTimeout(resolve, 500)) // delay retry
        //     return service(config)
        //     }
        // }

        const config = error?.config || {}
        const message = error?.response?.data?.message || 'Error'
        const data = error?.response?.data?.data || 'Error'
        // const status = error?.response?.status || null
        // const code = error?.code || null
        // const path = error?.response?.config?.url || config.url || 'unknown'
        if(!(error?.response)){
            return Promise.reject(error)
        }
        if (error?.response?.status) {
            console.log('%c[Axios Error Status Detected]:', 'color: #f87171; font-weight: bold;', error?.response?.status??'N/A')
        } else {
            console.log('%c[Axios Error]: No response status found.', 'color: #fbbf24; font-weight: bold;', error?.response?.status??'N/A')
        }
        
        if (error?.response?.status === 401) {
            removeToken()
            window.location.reload()
        }

        if (error?.response?.status === 403) {
            router.push('/403')
        }

        if (error?.response?.status === 500) {
            // router.push('/500')
            // ElMessage({
            //     message: error?.response?.data?.message || 'Error',
            //     type: 'error',
            //     duration: 5 * 1000
            // })
            // ElNotification({
            //     title: error?.response?.data?.message || 'Error',
            //     type: 'error',
            //     duration: 5 * 1000,
            //     position: 'top-left',
            // })
        }

        if (config.silent) {
        return Promise.reject(error)
        }

        // const errorStore = useErrorStore()
        // errorStore.setError({ status, code, message, path })

        // if (error.message === 'Network Error' && error?.code === 'ERR_NETWORK_CHANGED') {
        // config.__retryCount = config.__retryCount || 0
        // if (config.__retryCount < 5) {
        //     config.__retryCount += 1
        //     await new Promise(resolve => setTimeout(resolve, 500))
        //     return service(config)
        //     }
        // }
        // const currentRoute = router.currentRoute.value.path
        // if (
        //     ['/401', '/403', '/404', '/500'].includes(currentRoute) ||
        //     status === lastErrorStatus
        // ) {
        //     return Promise.reject(error)
        // }

        // // 🟢 Redirect once per status
        // if ([401, 403, 404].includes(status)) {
        //     lastErrorStatus = status
        //     router.push(`/${status}`)
        // } else if (status >= 500) {
        //     lastErrorStatus = 500
        //     router.push('/500')
        // }

        // // 🕒 Reset guard after 2s so new unrelated errors still redirect
        // setTimeout(() => {
        // lastErrorStatus = null
        // }, 2000)
        
        if (data) {
            if (typeof data === 'object') {
                // eslint-disable-next-line no-unused-vars
                Object.entries(data).forEach(([key, value]) => {
                    if (Array.isArray(value)) {
                        for (const v of value) {
                            setTimeout(() => {
                                ElNotification({
                                    title: message,
                                    message: v,
                                    type: 'error',
                                    duration: 5 * 1000,
                                })
                            }, 100)
                        }
                    } else {
                        ElNotification({
                            title: message,
                            message: value,
                            type: 'error',
                            duration: 5 * 1000,
                        })
                    }
                })
            } else{
                ElNotification({
                    title: message,
                    message: data,
                    type: 'error',
                    duration: 5 * 1000,
                })
            }
        } else {
            ElNotification({
                title: message,
                type: 'error',
                duration: 5 * 1000,
            })
        }
        return Promise.reject(error)
    }
)

export default service
